// ==========================================================================
// Nav
// ==========================================================================

var API;

$(".js-navigation-mobile").mmenu({
 extensions: ["position-right"]
}, {
  classNames: {
    selected: "active"
  }
});

API = $(".js-navigation-mobile").data("mmenu");

$(".js-navigation-mobile-toggle").click(function() {
  API.open();
});


// Hover dropdown menu - once ready.. On hover - reveal dropdown navigation
$(document).ready(function(){
    $(".js-nav-dropdown").hide();
    $('li.js-hover-item').hover(function() {
        $(this).find('.js-nav-dropdown').fadeIn(10);
        $(this).addClass('js-active');
    }, function() {
        // $(this).find('.Navigation--dropdown').stop(true, true).delay(200).fadeOut(500);
        $(this).removeClass('js-active');
    });
});



// WEBPACK FOOTER //
// ./src/js/modules/_navigation.js